import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/button";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import InputField from "../../../components/InputField";
import DynamicTable from "../../../components/table";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { setSearchKeys } from "../../../lib/redux/slices/searchKeysSlice";
import { getAllAppointmentsByUserId } from "../../../services/appointmentFn";
import AppLoader from "./../../../components/apploader/index";
import useDebounce from "./../../../components/hooks/useDebounce";
import { t } from "i18next";

const headerData = [
  "bookingDateTime",
  "service",
  "measure",
  "durationTime",
  "amount",
  "status",
  // "invoice",
  "action",
];

const tableRows = [
  "date_time",
  "service_used",
  "service_inputs",
  "service_duration",
  "service_price",
  "service_status",
  // "download_invoice_btn",
  "actions",
];

const UserServiceTrackerPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [appointments, setAllAppointments] = useState([]);
  const userData = useSelector((state) => state.userReducer.user);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(searchKeys.serviceName, 1000);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  useEffect(() => {
    fetchAllAppointments(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const fetchAllAppointments = async (value) => {
    try {
      setIsLoading(true);
      const response = await getAllAppointmentsByUserId(userData?._id, value);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllAppointments(data);
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGotoDetail = (params) => {
    navigate(`/dashboard/service/detail/${params._id}`);
  };

  const renderMenuBar = () => {
    return (
      <Stack
        p={2}
        gap={2}
        bgcolor={"primary.light"}
        direction={{ xs: "column", sm: "row" }}
      >
        <InputField
          styleProps={{ width: { xs: "100%", md: "35%", xl: "30%" } }}
          InputStartIcon={<SearchIcon />}
          InputEndIcon={
            searchKeys.serviceName && (
              <CancelOutlinedIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(
                    setSearchKeys({
                      ...searchKeys,
                      serviceName: "",
                    })
                  );
                }}
              />
            )
          }
          placeholder={t("searchService")}
          value={searchKeys.serviceName}
          onChange={(e) => {
            dispatch(
              setSearchKeys({
                ...searchKeys,
                serviceName: e.target.value,
              })
            );
          }}
        />
      </Stack>
    );
  };

  const renderHeaderServices = () => {
    return (
      <Stack
        p={2}
        gap={2}
        // bgcolor={"primary.light"}
        direction={{ xs: "column", sm: "row" }}
      >
        <GlobalButton
          btnText={"createNewAppointment"}
          handleClickBtn={() => navigate("/")}
          styleProps={{
            width: "auto",
            height: 40,
          }}
        />
      </Stack>
    );
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("trackAllAppointment")}
        secondaryHeading={t("trackAppointmentDetails")}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
        menuBarProps={renderMenuBar()}
        headProps={renderHeaderServices()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={appointments}
          showDetail={true}
          handleTrack={handleGotoDetail}
        />

        {appointments?.length === 0 && (
          <Typography
            variant="h5"
            fontWeight={600}
            textAlign={"center"}
            mt={3}
            textTransform={"capitalize"}
          >
            {t("noDataFound")}!
          </Typography>
        )}
      </CustomContainer>
    </DashboardHeader>
  );
};

export default UserServiceTrackerPage;
